module.exports = __webpack_public_path__ + "static/img/faceintroduce.4f86788.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/faceintroduce.png
// module id = 975
// module chunks = 41